// src/pages/produtos/unMedida/UnMedidaCad.js
// pages/produtos/unMedida/UnMedidaCad.js
import React, { useState, useEffect } from 'react';

import UnMedidaSearch from './UnMedidaSearch';
import { UnMedida } from '../../../models/produtos/UnMedida';
import { useUnMedida } from '../../../contexts/produtos/UnMedidaContext';
import Input from '../../../components/input/Input';
import { useMessage } from '../../../contexts/geral/MessageContext';
import { useYesNo } from '../../../contexts/geral/YesNoContext';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalActions, { ModalActionButton } from '../../../components/modalForm/ModalActions';

const UnMedidaCad = ({ show, onHide, unidadeMedida: initialUnMedida }) => {
    const { unMedidas, addUnMedida, updateUnMedida, deleteUnMedida } = useUnMedida();

    const [unMedida, setUnMedida] = useState(initialUnMedida || new UnMedida());
    const [showSearchModal, setShowSearchModal] = useState(false);
    const {showMessage} = useMessage();
    const { showYesNo } = useYesNo();

    const [novoReg, setNovoReg] = useState(!initialUnMedida);
    const [titulo, setTitulo] = useState(initialUnMedida ? 'Editar Unidade de Medida' : 'Nova Unidade de Medida');

    useEffect(() => {
        if (initialUnMedida) {
            setUnMedida(initialUnMedida);
            setNovoReg(false);
            setTitulo('Editar Unidade de Medida');
        } else {
            setUnMedida(new UnMedida());
            setNovoReg(true);
            setTitulo('Nova Unidade de Medida');
        }
    }, [initialUnMedida]);

    const handleNovo = () => {
        setUnMedida(new UnMedida());
        setNovoReg(true);
        setTitulo('Nova Unidade de Medida');
    };

    const handleEditar = (sigla) => {
        if (!sigla) {
            showMessage("Selecione uma unidade de medida para editar!");            
            return;
        }
        setNovoReg(false);
        setTitulo('Editar Unidade de Medida');
    };

    const handleDelete = async () => {
        if (!unMedida?.sigla) {
            showMessage("Selecione uma unidade de medida para excluir!");            
        } else {
            const resposta = await showYesNo("Deseja excluir a unidade de medida selecionada?");
            if (resposta) {
                await deleteUnMedida(unMedida.sigla);
                handleNovo();
            }
        }
        setNovoReg(true);
    };

    const handleSave = async () => {
        let unidadeSelecionada;
        if (unMedidas)
        {
            unidadeSelecionada = unMedidas.find(u => (
                u?.sigla?.toUpperCase() === unMedida?.sigla?.toUpperCase()
            ));
        }     

        const unidadeSalva = !unidadeSelecionada
            ? await addUnMedida(unMedida)
            : await updateUnMedida(unMedida);

        if (unidadeSalva) {
            console.log('Unidade de Medida salva:', unidadeSalva);
            handleNovo();
        }
    };

    const handleExit = () => {
        let unidadeSelecionada;
        if (unMedidas)
        {
            unidadeSelecionada = unMedidas.find(u => (
                u?.sigla?.toUpperCase() === unMedida?.sigla?.toUpperCase()
            ));
        }        

        if (unidadeSelecionada) {
            setUnMedida(unidadeSelecionada);
            handleEditar(unidadeSelecionada.sigla);
        } else {
            setUnMedida(new UnMedida(unMedida?.sigla,unMedida?.descricao));
        }
    };

    const handleSelectUnidadeMedida = (unidadeSelecionada) => {
        setUnMedida(unidadeSelecionada);
        setShowSearchModal(false);
        if (unidadeSelecionada) {            
            handleEditar(unidadeSelecionada.sigla);
        } else {
            setUnMedida(new UnMedida());
        }
    };

    if (!show) return null;

    return (
        <>        
            <ModalContainer show={show} variant="cadastro" onHide={onHide}>
                <ModalHeader title={titulo} onHide={onHide} />
                <ModalBody className="modal-body">
                    <form>
                        <div className="input-group mb-3">
                            <Input
                                label="Código"
                                value={unMedida.sigla || ''}
                                onChange={(e) => setUnMedida({ ...unMedida, sigla: e.target.value })}
                                onBlur={handleExit}
                                disabled={!novoReg}
                                btnBuscar={() => setShowSearchModal(true)}
                            />    

                            <Input
                                label="Descrição"
                                value={unMedida.descricao || ''}
                                onChange={(e) => setUnMedida({ ...unMedida, descricao: e.target.value })}
                                size={300}
                                autoFocus={true}                                    
                            />                                                                   
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter className="modal-footer justify-content-end">
                    <ModalActions >
                        <ModalActionButton type='button' className="btn btn-primary" onClick={handleSave} action="save">
                            Salvar
                        </ModalActionButton>
                        <ModalActionButton type='button' className="btn btn-danger" onClick={handleDelete} disabled={novoReg}  action="delete">
                            Excluir
                        </ModalActionButton>
                        <ModalActionButton type='button' className="btn btn-secondary" onClick={handleNovo} disabled={novoReg}  action="new">
                            Novo
                        </ModalActionButton>
                    </ModalActions>
                </ModalFooter>
            </ModalContainer>

            <UnMedidaSearch
                show={showSearchModal}
                onHide={() => setShowSearchModal(false)}                
                onSelectUnMedida={handleSelectUnidadeMedida} // Linha corrigida
            />
        </>        
    );
};

export default UnMedidaCad;
